import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../hooks/useStore';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import Popup from '../../../../components/common-components/pop-up/Popup';
import { FormikTextField } from '../../../../components/form-components/common-components/text-field/FormikTextField';
import CommonButton from '../../../../components/common-components/button/CommonButton';
import styles from './EditUserModal.module.css';
import { toast } from 'react-toastify';

interface EditUserModalProps {
  open: boolean;
  onClose: () => void;
}

interface FormValues {
  username: string;
  email: string;
  role: string;
  isActive: boolean;
}

const validationSchema = Yup.object({});

const EditUserModal: React.FC<EditUserModalProps> = ({ open, onClose }) => {
  const { userManagementStore } = useStore();
  const selectedUser = userManagementStore.selectedUser;
  const [roles, setRoles] = useState<string[]>([]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await userManagementStore.getRoles();
        if (response && response.length > 0) {
          setRoles(response);
        } else {
          toast.error('Rol bulunamadı');
        }
      } catch (error) {
        console.error('Roller yüklenirken hata:', error);
        toast.error('Roller yüklenirken bir hata oluştu');
      }
    };

    if (open) {
      fetchRoles();
    }
  }, [open]);

  const handleSubmit = async (values: FormValues) => {
    if (selectedUser?.id) {
      try {
        await userManagementStore.updateUser(selectedUser.id, values);
        onClose();
        toast.success('Kullanıcı başarıyla güncellendi');
      } catch (error) {
        console.error('Update error:', error);
        toast.error('Güncelleme sırasında bir hata oluştu');
      }
    }
  };

  const initialValues: FormValues = {
    username: selectedUser?.userName || '',
    email: selectedUser?.email || '',
    role: selectedUser?.roles?.[0] || '',
    isActive: selectedUser?.isActive || false,
  };

  return (
    <Popup isOpen={open} onClose={onClose} title="Kullanıcı Düzenle">
      <div className={styles.container}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ isSubmitting, setFieldValue, values }) => (
            <Form className={styles.form}>
              <div className={styles.formContent}>
                <div className={styles.inputContainer}>
                  <FormikTextField
                    name="username"
                    label="Kullanıcı Adı"
                    placeholder="Kullanıcı adı giriniz"
                    disabled={true}
                  />
                </div>

                <div className={styles.inputContainer}>
                  <FormikTextField
                    name="email"
                    label="E-posta"
                    placeholder="E-posta giriniz"
                    disabled={true}
                  />
                </div>

                <div className={styles.inputContainer}>
                  <label className={styles.label}>
                    Rol
                    <select
                      className={styles.select}
                      value={values.role}
                      onChange={e => setFieldValue('role', e.target.value)}
                    >
                      <option value="">Rol seçiniz</option>
                      {roles.map(role => (
                        <option key={role} value={role}>
                          {role}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>

                <div className={styles.inputContainer}>
                  <label className={styles.checkboxLabel}>
                    <input
                      type="checkbox"
                      checked={values.isActive}
                      onChange={e => setFieldValue('isActive', e.target.checked)}
                      className={styles.checkbox}
                    />
                    Aktif Mi?
                  </label>
                </div>
              </div>

              <div className={styles.buttons}>
                <CommonButton type="secondary" onClick={onClose}>
                  İptal
                </CommonButton>
                <CommonButton type="primary" disabled={isSubmitting} loading={isSubmitting}>
                  Kaydet
                </CommonButton>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Popup>
  );
};

export default observer(EditUserModal);
